import React from "react";
import "../App.css";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const InitialView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hexInput = location.state.hexkey;
  const userInput = location.state.hexuserInput;

  const firstpage = () => {
    navigate("/input");
  };

  const secondpage = () => {
    navigate("/page2", { state: { allResults, allEncResults, userInput, hexInput } });
  };

  function createArrayInOrder(hexInput) {
    // Split the input string into individual hex values
    const hexValues = hexInput.split(" ");

    // Initialize an array to store the elements in the desired order
    const orderedArray = [];

    // Determine the number of elements and the number of columns
    const numElements = hexValues.length;
    const numColumns = 4;

    for (let column = 0; column < numColumns; column++) {
      for (let row = 0; row < numElements; row += numColumns) {
        const index = row + column;
        if (index < numElements) {
          orderedArray.push(hexValues[index]);
        }
      }
    }

    return orderedArray;
  }

  function splitHexValue(hexValue) {
    // Split the input hexValue into individual hex values
    const hexValues = hexValue.split(" ");

    // Initialize variable arrays w0, w1, w2, and w3
    const w0 = hexValues.slice(0, 4);
    const w1 = hexValues.slice(4, 8);
    const w2 = hexValues.slice(8, 12);
    const w3 = hexValues.slice(12, 16);

    return { w0, w1, w2, w3 };
  }

  const orderedArray = createArrayInOrder(hexInput);
  console.log("array: ", orderedArray);
  const { w0, w1, w2, w3 } = splitHexValue(hexInput);

  const rows = [];
  for (let i = 0; i < orderedArray.length; i += 4) {
    rows.push(orderedArray.slice(i, i + 4));
  }
  console.log("rows: ", rows);

  function RotWord(word) {
    if (word.length !== 4) {
      throw new Error("Input word array must contain exactly 4 elements.");
    }

    // Create a new array for the rotated word
    const rotatedWord = [...word]; // Copy the elements from the original array

    // Perform the RotWord operation (left circular shift) on the new array
    const temp = rotatedWord[0];
    for (let i = 0; i < 3; i++) {
      rotatedWord[i] = rotatedWord[i + 1];
    }
    rotatedWord[3] = temp;

    return rotatedWord;
  }

  const rotatedWord = RotWord(w3);

  const sBox = [
    "52", "09", "6a", "d5", "30", "36", "a5", "38", "bf", "40", "a3", "9e", "81", "f3", "d7", "fb",
    "7c", "e3", "39", "82", "9b", "2f", "ff", "87", "34", "8e", "43", "44", "c4", "de", "e9", "cb",
    "54", "7b", "94", "32", "a6", "c2", "23", "3d", "ee", "4c", "95", "0b", "42", "fa", "c3", "4e",
    "08", "2e", "a1", "66", "28", "d9", "24", "b2", "76", "5b", "a2", "49", "6d", "8b", "d1", "25",
    "72", "f8", "f6", "64", "86", "68", "98", "16", "d4", "a4", "5c", "cc", "5d", "65", "b6", "92",
    "6c", "70", "48", "50", "fd", "ed", "b9", "da", "5e", "15", "46", "57", "a7", "8d", "9d", "84",
    "90", "d8", "ab", "00", "8c", "bc", "d3", "0a", "f7", "e4", "58", "05", "b8", "b3", "45", "06",
    "d0", "2c", "1e", "8f", "ca", "3f", "0f", "02", "c1", "af", "bd", "03", "01", "13", "8a", "6b",
    "3a", "91", "11", "41", "4f", "67", "dc", "ea", "97", "f2", "cf", "ce", "f0", "b4", "e6", "73",
    "96", "ac", "74", "22", "e7", "ad", "35", "85", "e2", "f9", "37", "e8", "1c", "75", "df", "6e",
    "47", "f1", "1a", "71", "1d", "29", "c5", "89", "6f", "b7", "62", "0e", "aa", "18", "be", "1b",
    "fc", "56", "3e", "4b", "c6", "d2", "79", "20", "9a", "db", "c0", "fe", "78", "cd", "5a", "f4",
    "1f", "dd", "a8", "33", "88", "07", "c7", "31", "b1", "12", "10", "59", "27", "80", "ec", "5f",
    "60", "51", "7f", "a9", "19", "b5", "4a", "0d", "2d", "e5", "7a", "9f", "93", "c9", "9c", "ef",
    "a0", "e0", "3b", "4d", "ae", "2a", "f5", "b0", "c8", "eb", "bb", "3c", "83", "53", "99", "61",
    "17", "2b", "04", "7e", "ba", "77", "d6", "26", "e1", "69", "14", "63", "55", "21", "0c", "7d"
  ];

  function SubWord(rotWord) {
    if (rotWord.length !== 4) {
      throw new Error("Input word array must contain exactly 4 elements.");
    }

    // Apply the S-Box transformation to each byte of the RotWord
    const subWord = rotWord.map((byte) => sBox[parseInt(byte, 16)]);

    return subWord;
  }

  const subWord = SubWord(rotatedWord);
  console.log("sub", subWord);

  const roundConstants = [
    ["01", "00", "00", "00"],
    ["02", "00", "00", "00"],
    ["04", "00", "00", "00"],
    ["08", "00", "00", "00"],
    ["10", "00", "00", "00"],
    ["20", "00", "00", "00"],
    ["40", "00", "00", "00"],
    ["80", "00", "00", "00"],
    ["1B", "00", "00", "00"],
    ["36", "00", "00", "00"],
  ];

  function AddRoundConstant(subWord, round) {
    if (subWord.length !== 4) {
      throw new Error("Input subWord array must contain exactly 4 elements.");
    }

    // Get the round constant for the specified round
    const roundConstant = roundConstants[round - 1];

    // XOR the SubWord with the round constant
    const gWi = subWord.map((byte, index) =>
      (parseInt(byte, 16) ^ parseInt(roundConstant[index], 16))
        .toString(16)
        .padStart(2, "0")
    );

    return gWi;
  }
  const round = 1;
  const gWi = AddRoundConstant(subWord, round);
  console.log("gWi", gWi);

  function XORWords(w0, gWi) {
    if (w0.length !== 4 || gWi.length !== 4) {
      throw new Error("Input arrays must contain exactly 4 elements.");
    }

    const w4 = w0.map((byte, index) =>
      (parseInt(byte, 16) ^ parseInt(gWi[index], 16))
        .toString(16)
        .padStart(2, "0")
    );

    return w4;
  }

  let words = [w0, w1, w2, w3];
  let rotwordarray = [];
  let subwordarray = [];
  let gwiarray = [];
  let allResults = [];

  function AESkeyGeneration(hexInput) {
    let rotWordindex = 3;
    for (let i = 0; i < 10; i++) {
      let rotatedWord = RotWord(words[rotWordindex]);
      rotwordarray.push(rotatedWord);
      subwordarray.push(SubWord(rotatedWord));
      gwiarray.push(AddRoundConstant(SubWord(rotatedWord), i + 1));

      words.push(XORWords(words[rotWordindex - 3], gwiarray[i]));
      for (let j = 2; j > -1; j--) {
        words.push(XORWords(words[rotWordindex - j], words[words.length - 1]));
      }
      rotWordindex = rotWordindex + 4;
    }
    allResults.push(rotwordarray);
    allResults.push(subwordarray);
    allResults.push(gwiarray);
    allResults.push(words);
    allResults.push(hexInput);
  }

  AESkeyGeneration(hexInput);
  console.log(allResults);

  const subkeys = [];

  // Assuming each subkey is made up of 4 words
  for (let i = 0; i < 44; i += 4) {
    const subkey = allResults[3].slice(i, i + 4);
    subkeys.push(subkey);
  }

  console.log("userInput", userInput);
  console.log("subkeys", subkeys);

  // Convert a space-separated hex string to an array of bytes
  function hexStringToArray(hexString) {
    return hexString.split(" ").map((hex) => parseInt(hex, 16));
  }

  // Convert an array of bytes to a space-separated hex string
  function arrayToHexString(byteArray) {
    return byteArray
      .map((byte) =>
        typeof byte === "number" ? byte.toString(16).padStart(2, "0") : ""
      )
      .filter((hexByte) => hexByte !== "")
      .join(" ");
  }

  // Apply the AddRoundKey transformation using a key of 16 bytes
  function initialTransformation(userInput, keyBytes) {
    // Convert the hex string input to an array of bytes
    const inputBytes = hexStringToArray(userInput);

    // Ensure the input and key have the same length (16 bytes)
    if (inputBytes.length !== 16 || keyBytes.length !== 16) {
      console.log("inputBytes.length", inputBytes.length);
      console.log("keyBytes.length", keyBytes.length);
      throw new Error("Input and key must be 16 bytes long.");
    }

    // Apply the AddRoundKey transformation by XORing the input and key
    const resultBytes = inputBytes.map((byte, index) => byte ^ keyBytes[index]);

    // Convert the result back to a space-separated hex string
    const resultHex = arrayToHexString(resultBytes);

    return resultHex;
  }

  function splitAndByteSubstitute(hexString) {
    const bytes = hexString.split(" ").map((byte) => parseInt(byte, 16));
    const substitutedBytes = bytes.map((byte) => {
      const rowIndex = (byte >> 4) & 0xf; // Get the first 4 bits (row index)
      const colIndex = byte & 0xf; // Get the last 4 bits (column index)
      return sBox[rowIndex * 16 + colIndex];
    });
    return substitutedBytes;
  }
  // Example usage
  const keyBytes = hexStringToArray(hexInput);
  const transformedData = initialTransformation(userInput, keyBytes);

  console.log("Transformed Data:", transformedData);

  const substitutedBytes = splitAndByteSubstitute(transformedData);
  const substitutedHex = substitutedBytes
    .map((byte) => byte.toString(16).padStart(2, "0"))
    .join(" ");
  console.log("Substituted Data:", substitutedHex);

  function createMatrix(hexString) {
    const bytes = hexString.split(" ");
    const matrix = [];
    for (let i = 0; i < bytes.length; i += 4) {
      matrix.push(bytes.slice(i, i + 4));
    }
    return matrix;
  }

  function shiftRows(matrix) {
    for (let row = 1; row < 4; row++) {
      for (let shift = 0; shift < row; shift++) {
        const temp = matrix[row][3]; // Change: Store the last element in temp
        for (let col = 3; col > 0; col--) { // Change: Iterate from the last column to the first
          matrix[row][col] = matrix[row][col - 1]; // Change: Shift to the right
        }
        matrix[row][0] = temp; // Change: Set the first element to the stored temp
      }
    }
  }
  

  const orderedArray2 = createArrayInOrder(substitutedHex);
  console.log("array2: ", orderedArray2);
 

  const shiftedRows = [];
  for (let i = 0; i < orderedArray2.length; i += 4) {
    shiftedRows.push(orderedArray2.slice(i, i + 4));
  }

  shiftRows(shiftedRows);
  console.log("Shifted Rows Matrix:", shiftedRows);

  // mixColumns funtion performs a matrix multiplication

  function transposeMatrix(matrix) {
    const numRows = matrix.length;
    const numCols = matrix[0].length;

    const transposedMatrix = [];

    for (let col = 0; col < numCols; col++) {
      transposedMatrix[col] = [];
      for (let row = 0; row < numRows; row++) {
        transposedMatrix[col][row] = matrix[row][col];
      }
    }

    return transposedMatrix;
  }

  function mixColumns(state) {
    state = transposeMatrix(state);
    //console.log("state: ", state)
    const fixedMatrix = [
      [2, 3, 1, 1],
      [1, 2, 3, 1],
      [1, 1, 2, 3],
      [3, 1, 1, 2],
    ];

    const newState = [];

    for (let col = 0; col < 4; col++) {
      newState[col] = [];
      for (let row = 0; row < 4; row++) {
        let xorValues = [];
        newState[col][row] = "00"; // Initialize to "00"
        for (let i = 0; i < 4; i++) {
          const m = fixedMatrix[row][i];
          const s = state[col][i];
          const product = multiplyInGF(m, s);
          newState[col][row] = xorHexStrings(newState[col][row], product);
          xorValues.push(product);
        }
      }
    }

    return newState;
  }

  function leftShiftWithPadding(inputBinary, shiftAmount = 1) {
    // Check if the input binary string is exactly 8 bits long
    if (inputBinary.length !== 8) {
      console.error("Input binary string must be 8 bits long.");
      return null;
    }

    // Perform the left shift
    const shiftedBinary =
      inputBinary.slice(shiftAmount) + "0".repeat(shiftAmount);

    return shiftedBinary;
  }

  function bitwiseXOR(input1, input2) {
    // Check if the inputs are exactly 8 bits long

    // Perform the bitwise XOR operation
    let result = "";
    for (let i = 0; i < 8; i++) {
      result += input1[i] ^ input2[i];
    }

    return result;
  }

  function multiplyInGF(a, b) {
    let product = "";

    //multiplying with 01
    if (a == 1) {
      product = hexToBinary(b);
    }

    //multiplying with 02
    else if (a == 2) {
      let bin = hexToBinary(b);
      //console.log("bin: ",bin)
      let shiftedBin = leftShiftWithPadding(bin);
      //console.log("shiftedBin: ",shiftedBin)
      product = shiftedBin;
      if (bin[0] == "1") {
        product = bitwiseXOR(shiftedBin, "00011011");
      }
      //console.log("product: ",product)
    }

    //multiplying with 03
    else {
      let bin = hexToBinary(b);
      let shiftedBin = leftShiftWithPadding(bin);
      let mulWith2 = shiftedBin;
      if (bin[0] == "1") {
        mulWith2 = bitwiseXOR(shiftedBin, "00011011");
      }

      product = bitwiseXOR(bin, mulWith2);
    }
    let productHex = binaryToHex(product);
    return productHex;
  }

  function hexToBinary(hexString) {
    // Parse the hex string to an integer
    const decimalValue = parseInt(hexString, 16);

    // Convert the integer to an 8-bit binary string
    const binaryString = decimalValue.toString(2).padStart(8, "0");

    return binaryString;
  }

  function binaryToHex(binaryString) {
    const decimalValue = parseInt(binaryString, 2);
    const hexString = decimalValue.toString(16).toUpperCase();
    return hexString;
  }

  function xorHexStrings(a, b) {
    a = parseInt(a, 16);
    b = parseInt(b, 16);
    return (a ^ b).toString(16).padStart(2, "0");
  }

  const mixColumnsMatrix = mixColumns(shiftedRows);
  console.log("mix Columns matrix:", mixColumnsMatrix);

  function xorArrays(array1, array2) {
    if (array1.length !== 4 || array2.length !== 4) {
      throw new Error("Both input arrays must contain 4 elements.");
    }

    const result = [];

    for (let i = 0; i < 4; i++) {
      if (array1[i].length !== 4 || array2[i].length !== 4) {
        throw new Error(
          "Each element in the input arrays must contain 4 hexadecimal elements."
        );
      }

      const xorResult = array1[i].map((hex1, index) => {
        const hex2 = array2[i][index];
        const int1 = parseInt(hex1, 16);
        const int2 = parseInt(hex2, 16);
        const xorValue = int1 ^ int2;
        return xorValue.toString(16).padStart(2, "0");
      });

      result.push(xorResult);
    }

    return result;
  }

  const result = xorArrays(mixColumnsMatrix, subkeys[10]);
  console.log("result: ", result);


  const allEncResults = [];
  let input = [];
  let sub = [];
  let shift = [];
  let mix = [];
  let output = [];
  input.push(transformedData);
  sub.push(substitutedHex);
  shift.push(shiftedRows);
  mix.push(mixColumnsMatrix);
  output.push(result);

  
  

  function convertArrayToSpaceSeparatedString(arr) {
    let result = '';
    for (let i = 0; i < arr.length; i++) {
      for (let j = 0; j < arr[i].length; j++) {
        result += arr[i][j].join(' ') + ' ';
      }
    }
    return result.trim(); // Trim to remove the trailing space
  }

  const resultString2 = convertArrayToSpaceSeparatedString(output);
  console.log(resultString2);

  input.push(resultString2);

  const substitutedBytes2 = splitAndByteSubstitute(resultString2);
  const substitutedHex2 = substitutedBytes2.join(" ")
  sub.push(substitutedHex2);

  const orderedArray3 = createArrayInOrder(substitutedHex2);
  const shiftedRows2 = [];
  for (let i = 0; i < orderedArray3.length; i += 4) {
    shiftedRows2.push(orderedArray3.slice(i, i + 4));
  }

  shiftRows(shiftedRows2);

  shift.push(shiftedRows2);

  const mixColumnsMatrix2 = mixColumns(shiftedRows2);
  mix.push(mixColumnsMatrix2);

  const result2 = xorArrays(mixColumnsMatrix2, subkeys[9]);
  output.push(result2);
  let x = []
  x.push(result2);

  let resultString3 = convertArrayToSpaceSeparatedString(x);
  input.push(resultString3);

  const substitutedBytes3 = splitAndByteSubstitute(resultString3);
  const substitutedHex3 = substitutedBytes3.join(" ")
  sub.push(substitutedHex3);

  const orderedArray4 = createArrayInOrder(substitutedHex3);
  const shiftedRows3 = [];
  for (let i = 0; i < orderedArray4.length; i += 4) {
    shiftedRows3.push(orderedArray4.slice(i, i + 4));
  }
  shiftRows(shiftedRows3);
  shift.push(shiftedRows3);

  const mixColumnsMatrix3 = mixColumns(shiftedRows3);
  mix.push(mixColumnsMatrix3);

  const result3 = xorArrays(mixColumnsMatrix3, subkeys[8]);
  output.push(result3);
  let y = []
  y.push(result3);

  let resultString4 = convertArrayToSpaceSeparatedString(y);
  input.push(resultString4);

  const substitutedBytes4 = splitAndByteSubstitute(resultString4);
  const substitutedHex4 = substitutedBytes4.join(" ")
  sub.push(substitutedHex4);

  const orderedArray5 = createArrayInOrder(substitutedHex4);
  const shiftedRows4 = [];
  for (let i = 0; i < orderedArray5.length; i += 4) {
    shiftedRows4.push(orderedArray5.slice(i, i + 4));
  }
  shiftRows(shiftedRows4);
  shift.push(shiftedRows4);

  const mixColumnsMatrix4 = mixColumns(shiftedRows4);
  mix.push(mixColumnsMatrix4);

  const result4 = xorArrays(mixColumnsMatrix4, subkeys[7]);
  output.push(result4);
  let z = []
  z.push(result4);

  let resultString5 = convertArrayToSpaceSeparatedString(z);
  input.push(resultString5);

  const substitutedBytes5 = splitAndByteSubstitute(resultString5);
  const substitutedHex5 = substitutedBytes5.join(" ")
  sub.push(substitutedHex5);

  const orderedArray6 = createArrayInOrder(substitutedHex5);
  const shiftedRows5 = [];
  for (let i = 0; i < orderedArray6.length; i += 4) {
    shiftedRows5.push(orderedArray6.slice(i, i + 4));
  }

  shiftRows(shiftedRows5);
  shift.push(shiftedRows5);

  const mixColumnsMatrix5 = mixColumns(shiftedRows5);
  mix.push(mixColumnsMatrix5);

  const result5 = xorArrays(mixColumnsMatrix5, subkeys[6]);
  output.push(result5);
  let a = []
  a.push(result5);

  let resultString6 = convertArrayToSpaceSeparatedString(a);
  input.push(resultString6);

  const substitutedBytes6 = splitAndByteSubstitute(resultString6);
  const substitutedHex6 = substitutedBytes6.join(" ")
  sub.push(substitutedHex6);

  const orderedArray7 = createArrayInOrder(substitutedHex6);
  const shiftedRows6 = [];
  for (let i = 0; i < orderedArray7.length; i += 4) {
    shiftedRows6.push(orderedArray7.slice(i, i + 4));
  }

  shiftRows(shiftedRows6);
  shift.push(shiftedRows6);

  const mixColumnsMatrix6 = mixColumns(shiftedRows6);
  mix.push(mixColumnsMatrix6);

  const result6 = xorArrays(mixColumnsMatrix6, subkeys[5]);
  output.push(result6);
  let b = []
  b.push(result6);

  let resultString7 = convertArrayToSpaceSeparatedString(b);
  input.push(resultString7);

  const substitutedBytes7 = splitAndByteSubstitute(resultString7);
  const substitutedHex7 = substitutedBytes7.join(" ")
  sub.push(substitutedHex7);

  const orderedArray8 = createArrayInOrder(substitutedHex7);
  const shiftedRows7 = [];
  for (let i = 0; i < orderedArray8.length; i += 4) {
    shiftedRows7.push(orderedArray8.slice(i, i + 4));
  }

  shiftRows(shiftedRows7);
  shift.push(shiftedRows7);

  const mixColumnsMatrix7 = mixColumns(shiftedRows7);
  mix.push(mixColumnsMatrix7);

  const result7 = xorArrays(mixColumnsMatrix7, subkeys[4]);
  output.push(result7);
  let c = []
  c.push(result7);

  let resultString8 = convertArrayToSpaceSeparatedString(c);
  input.push(resultString8);

  const substitutedBytes8 = splitAndByteSubstitute(resultString8);
  const substitutedHex8 = substitutedBytes8.join(" ")
  sub.push(substitutedHex8);

  const orderedArray9 = createArrayInOrder(substitutedHex8);
  const shiftedRows8 = [];
  for (let i = 0; i < orderedArray9.length; i += 4) {
    shiftedRows8.push(orderedArray9.slice(i, i + 4));
  }

  shiftRows(shiftedRows8);
  shift.push(shiftedRows8);

  const mixColumnsMatrix8 = mixColumns(shiftedRows8);
  mix.push(mixColumnsMatrix8);

  const result8 = xorArrays(mixColumnsMatrix8, subkeys[3]);
  output.push(result8);

  let d = []
  d.push(result8);

  let resultString9 = convertArrayToSpaceSeparatedString(d);
  input.push(resultString9);

  const substitutedBytes9 = splitAndByteSubstitute(resultString9);
  const substitutedHex9 = substitutedBytes9.join(" ")
  sub.push(substitutedHex9);

  const orderedArray10 = createArrayInOrder(substitutedHex9);
  const shiftedRows9 = [];
  for (let i = 0; i < orderedArray10.length; i += 4) {
    shiftedRows9.push(orderedArray10.slice(i, i + 4));
  }

  shiftRows(shiftedRows9);
  shift.push(shiftedRows9);

  const mixColumnsMatrix9 = mixColumns(shiftedRows9);
  mix.push(mixColumnsMatrix9);

  const result9 = xorArrays(mixColumnsMatrix9, subkeys[2]);
  output.push(result9);

  let e = []
  e.push(result9);

  let resultString10 = convertArrayToSpaceSeparatedString(e);
  input.push(resultString10);

  const substitutedBytes10 = splitAndByteSubstitute(resultString10);
  const substitutedHex10 = substitutedBytes10.join(" ")
  sub.push(substitutedHex10);

  const orderedArray11 = createArrayInOrder(substitutedHex10);
  const shiftedRows10 = [];
  for (let i = 0; i < orderedArray11.length; i += 4) {
    shiftedRows10.push(orderedArray11.slice(i, i + 4));
  }

  shiftRows(shiftedRows10);
  shift.push(shiftedRows10);

  const mixColumnsMatrix10 = mixColumns(shiftedRows10);
  mix.push(mixColumnsMatrix10);

  const transpose = shiftedRows10[0].map((_, colIndex) => shiftedRows10.map(row => row[colIndex]));

  const result10 = xorArrays(transpose, subkeys[1]);
  output.push(result10);


  allEncResults.push(input);
  allEncResults.push(sub);
  allEncResults.push(shift);
  allEncResults.push(mix);
  allEncResults.push(output);
  allEncResults.push(subkeys);

  console.log("allEncResults", allEncResults);

  let Finalans = allEncResults[4][9].map(row => row.join(' ')).join('\n');


  return (
    <>
      <div className="input-container">
        <div className="flex flex-col items-center">
          <motion.div 
          initial = {{opacity: 0, scale: 0.5}}
          animate = {{opacity: 1 , scale: 1}}
          className="pt-10">
            <h1>Hex Value of Plaintext: {userInput}</h1>
            <h1>Hex Value of Key: {hexInput}</h1>
            <h1>Final decrypted Plaintext : {Finalans}</h1>

            <br />
          </motion.div>

          <motion.div
          initial = {{opacity: 0}}
          animate = {{opacity: 1}}
          transition = {{duration: 1}}
           className="flex flex-col">
            <p className="text-xl font-semibold align-middle pb-4">Keys Generated</p>
            <table className="min-w-full divide-y divide-gray-200">
              <thead>
                <tr>
                  <th class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">Subkey Number</th>
                  <th class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">Word 0</th>
                  <th class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">Word 1</th>
                  <th class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">Word 2</th>
                  <th class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">Word 3</th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
                {subkeys.map((subkey, index) => (
                  <tr key={index}>
                    <td class="px-3 py-2 whitespace-nowrap">{index}</td>
                    {subkey.map((word, i) => (
                      <td key={i}>{word.join(" ")}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </motion.div>

          <div class="button-holder">
            <div class="prev-button" onClick={firstpage}>
              PREVIOUS
            </div>
            <div className="next-button" onClick={secondpage}>
              NEXT
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InitialView;
